var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7 6.88L17.14 0.28L16.44 0H1L0 1V12H2V2H14V9L15 10H22V12H24V7.6L23.7 6.88ZM16 8V2L22 8H16ZM1 14L0 15V27L1 28H23L24 27V15L23 14H1ZM22 24V26H2V16H22V24Z",
    fill: "#585C64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36914 22.9419V18.5508H8.18303C8.51179 18.5508 8.79553 18.6151 9.03424 18.7437C9.27437 18.871 9.45948 19.0489 9.58955 19.2776C9.71963 19.5049 9.78466 19.7693 9.78466 20.0709C9.78466 20.374 9.7182 20.6391 9.58526 20.8664C9.45376 21.0922 9.2658 21.2673 9.02137 21.3917C8.77695 21.516 8.48678 21.5782 8.15087 21.5782H7.03166V20.742H7.95362C8.11371 20.742 8.24736 20.7142 8.35456 20.6584C8.46319 20.6027 8.54538 20.5248 8.60113 20.4247C8.65688 20.3232 8.68475 20.2053 8.68475 20.0709C8.68475 19.9351 8.65688 19.8179 8.60113 19.7193C8.54538 19.6192 8.46319 19.5421 8.35456 19.4877C8.24593 19.4334 8.11228 19.4063 7.95362 19.4063H7.43046V22.9419H6.36914Z",
    fill: "#585C64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9309 22.9419H10.3078V18.5508H11.9287C12.3761 18.5508 12.7614 18.6387 13.0844 18.8145C13.4089 18.9889 13.659 19.2405 13.8348 19.5692C14.0107 19.8966 14.0986 20.2882 14.0986 20.7442C14.0986 21.2016 14.0107 21.5947 13.8348 21.9234C13.6604 22.2522 13.411 22.5045 13.0866 22.6803C12.7621 22.8547 12.3769 22.9419 11.9309 22.9419ZM11.3691 22.0371H11.8902C12.136 22.0371 12.344 21.9956 12.5141 21.9127C12.6856 21.8284 12.815 21.6919 12.9022 21.5032C12.9908 21.3131 13.0351 21.0601 13.0351 20.7442C13.0351 20.4283 12.9908 20.1767 12.9022 19.9895C12.8135 19.8008 12.6827 19.665 12.5098 19.5821C12.3383 19.4978 12.1267 19.4556 11.8751 19.4556H11.3691V22.0371Z",
    fill: "#585C64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7182 22.9419V18.5508H17.7156V19.4127H15.7795V20.3132H17.5248V21.1773H15.7795V22.9419H14.7182Z",
    fill: "#585C64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4b0e97947c9a00cd21e8ec8cb3d01e46.svg";
export { ForwardRef as ReactComponent };